import React from "react";
import PropTypes from "prop-types";

function RequiredConnectionMessage({ crm }) {
  return (
    <div data-test="required-crm-connection-msg">
      <p>
        Someone on your team has linked your Hub with {crm}. To keep enjoying
        the full benefits of Hubly, you must connect your Hubly and {crm}{" "}
        accounts.
      </p>

      <ul>
        <li>
          Hubly will have access to your {crm} personal account information,
          including all contact records, details, comments, and tags.
        </li>

        <li>
          Once you connect your Hubly and {crm} accounts, a sync will start and
          you won&apos;t be able to see your clients until the sync in
          completed.
        </li>
      </ul>
    </div>
  );
}

RequiredConnectionMessage.propTypes = {
  crm: PropTypes.string.isRequired,
};

RequiredConnectionMessage.defaultProps = {};

export default RequiredConnectionMessage;
